import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=288ec2fe&scoped=true&"
import script from "./resetPwd.js?vue&type=script&lang=js&"
export * from "./resetPwd.js?vue&type=script&lang=js&"
import style0 from "./resetPwd.scss?vue&type=style&index=0&id=288ec2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ec2fe",
  null
  
)

export default component.exports